
import { Component, Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import scroll from '@/mixins/scroll'
import GoodsCard from '@/views/industryMall/shop/template/GoodsCard.vue'
import SkeletonCard from '@/views/industryMall/shop/template/SkeletonCard.vue'
import whitePayPopup from '@/components/whitePayPopup/index.vue'
import NoticeBar from '@/components/NoticeBar/index.vue'
import SearchNav from '@/views/industryMall/shop/template/SearchNav.vue'
import ActivitySegment from '@/views/industryMall/shop/template/ActivitySegment.vue'
import {
  getCyStoreGoodsList,
  getCyStoreActivityGoodsList,
  ShopGoodsInfoDto
} from '@/api/industryMall'
import { TabDto } from '@/api/goodsModule'
import { getStoreShoppingCart } from '@/api/industryMall'
import { LoginReturnDataDto, backToBefore } from '@/utils/h5ToApp'
import store from '@/store'

@Component({
  name: 'Mall',
  components: { GoodsCard, SkeletonCard, whitePayPopup, SearchNav, NoticeBar, ActivitySegment }
})
export default class Mall extends Mixins(scroll) {
  @Getter companyId!: string
  @Getter providerId!: string
  @Getter info!: LoginReturnDataDto
  @Getter tabModules!: Array<TabDto>
  // @Getter topSafetyHeight!: number
  @Getter partnerCompanyId!: string
  @Action clearMallStore!: () => void
  activityData: any = {} // 活动数据

  refreshing = false
  finished = false
  loading = false

  skeletonList: any[] = [{}, {}, {}, {}]
  goodsList: any[] = []
  activeGoods: ShopGoodsInfoDto[] = []

  params = {
    pageIndex: 1,
    pageSize: 10,
    partnerCompanyId: '', // 合作方企业编号
    keyword: '',
    companyId:''
  }
  // 瀑布流数据
  Hs = [0, 0]
  gap = 10
  nodes = []
  fragElement = null
  isActivated = false
  isLoadComplete = false
  isShowSkeleton = true

  get isTabModule () {
    const module = this.tabModules.find(t => t.route === '/mall')
    return (module && module.isShow) || false
  }

  /**
   * 初始化瀑布流
   */
  fragInit() {
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'fragInit方法',
      type: '函数执行'
    })
    this.nodes = Array.from(document.getElementsByClassName('goods-list'))
    this.Hs = [0, 0]
    this.fragElement = document.createDocumentFragment()
    if (this.nodes.length) {
      this.reset()
      this.isLoadComplete = true
    }
  }

  /**
   * 瀑布流重排
   */
  reset() {
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'reset方法',
      type: '函数执行'
    })
    this.nodes.forEach((item) => {
      // 获取高度小的一边
      let tag = this.Hs.indexOf(Math.min(...this.Hs))
      item.style.position = 'absolute'
      item.style.top = this.Hs[tag] + 'px'
      item.style.left = tag * (item.offsetWidth + this.gap) + 'px'
      // 增加高度距离
      this.Hs[tag] += item.offsetHeight + this.gap
      this.fragElement.appendChild(item)
    })
    let frag = this.Hs.indexOf(Math.max(...this.Hs))
    if (document.getElementsByClassName('lists') && document.getElementsByClassName('lists').length) {
      // @ts-ignore
      document.getElementsByClassName('lists')[0].style.height = this.Hs[frag] + 'px'
      // 插入文档中
      document.getElementsByClassName('lists')[0].appendChild(this.fragElement)
    }
  }

  created() {
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'created方法',
      type: '进入页面'
    })
    this.clearMallStore()
    this.params.partnerCompanyId = this.info.partnerCompanyId || 'system'
    this.params.companyId = this.companyId
    this.init()
  }

  mounted () {
    this.$addScrollListener('.mall-refresh')
    store.dispatch('getShopCarNum', this.info.partnerCompanyId)
    this.reloadPage()
  }

  activated() {
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'activated方法',
      type: '函数执行'
    })
    console.log('activated----isActivated', this.isActivated)
    console.log('activated----isLoadComplete', this.isLoadComplete)
    if (this.isActivated) {
      this.$setScrollY()
      this.refreshShoppingGoodsCount()
      this.$refs.activity && (this.$refs.activity as any).getIsShow()
    } else {
      this.isActivated = true
    }
    if (!this.isLoadComplete) {
      this.changeList()
    }
  }

  changeList () {
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'changeList方法',
      type: '函数执行'
    })
    let list = JSON.parse(JSON.stringify(this.goodsList))
    this.goodsList = []
    this.params.pageIndex = 1
    this.loading = false
    this.finished = false
    setTimeout(() => {
      this.goodsList = list
      this.reloadPage()
      // this.isLoadComplete = true
    })
  }

  deactivated () {
    this.$removeScrollListener()
  }

  init() {
    this.getStoreActivityList()
    this.getGoodsList()
    // this.onLoad()
  }

  onLoad() {
    this.loading = true
    this.params.pageIndex++
    this.getGoodsList()
  }

  /**
   * 重新请求数据
   */
  reloadList() {
    this.params.pageIndex = 1
    this.goodsList = []
    this.getGoodsList()
  }

  /**
   * 页面重排
   */
  reloadPage() {
    this.$nextTick(() => {
      this.fragInit()
    })
  }

  /**
   * 跳转商品详情
   */
  toDetail(item: ShopGoodsInfoDto) {
    if (item.goodsStatus === 2) {
      this.$dialog
        .alert({
          message: '商品过期不存在'
        })
        .then(() => {
          this.getStoreActivityList()
        })
      return
    }
    this.$router.push({
      path: '/goodsMallDetail',
      query: {
        goodsId: item.goodsId,
        storeId: item.storeId
      }
    })
  }

  /**
   * 获取折扣商品列表
   */
  getStoreActivityList() {
    let params = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      // activityId:'',// 暂时先不传 沟通人 魏子皓
      pageSize: 2,
      pageIndex: 1
    }
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'getStoreActivityList方法',
      type: '函数执行',
      data: params
    })
    getCyStoreActivityGoodsList(params).then((res) => {
      this.$log.setLog({
        file: 'shop/index.vue',
        name: 'getStoreActivityList方法',
        type: '函数执行-成功'
      })
      this.activeGoods = res.data.records
    }).catch(err => {
      this.$log.setLog({
        file: 'shop/index.vue',
        name: 'getStoreActivityList方法',
        type: '函数执行-失败',
        data: err
      })
    })
  }

  /**
   * 获取商品列表
   */
  getGoodsList() {
    this.$log.setLog({
      file: 'shop/index.vue',
      name: 'getGoodsList方法',
      type: '函数执行',
      data: this.params
    })
    getCyStoreGoodsList({ ...this.params }, false)
      .then((res) => {
        this.$log.setLog({
          file: 'shop/index.vue',
          name: 'getGoodsList方法',
          type: '函数执行-成功'
        })
        if (this.refreshing) {
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records)
        // 判断是否展示骨架屏
        if (res.data.totalPages) {
          this.isShowSkeleton = true
        } else {
          this.isShowSkeleton = false
        }
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch((err) => {
        this.finished = true
        this.$log.setLog({
          file: 'shop/index.vue',
          name: 'getGoodsList方法',
          type: '函数执行-失败',
          data: err
        })
      })
      .finally(() => {
        this.isLoadComplete = false
        this.reloadPage()
        this.refreshing = false
        this.loading = false
        this.$nextTick(() => {
          this.$log.setLog({
            file: 'shop/index.vue',
            name: 'getGoodsList方法',
            type: '记录结束'
          })
          // this.$log.getLog()
        })
      })
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.refreshing = true
    this.params.pageIndex = 1
    this.init()
    this.$refs.activity && (this.$refs.activity as any).refresh()
  }

  /**
   * 去历史记录页
   */
  toHistory() {
    this.$router.push({
      path: '/MallSearchHistory',
      query: {
        searchType: '1',
        storeId: this.partnerCompanyId
      }
    })
  }

  goMore() {
    this.$router.push({
      path: '/discountSale'
    })
  }

  /** 刷新商品在购物车中的数量 */
  refreshShoppingGoodsCount () {
    getStoreShoppingCart({
      partnerCompanyId: this.info.partnerCompanyId,
      pageIndex: 1,
      pageSize: 100
    }).then((res) => {
      const shoppingGoods = []
      res.data.records.forEach(shop => {
        shoppingGoods.push(...shop.goodsPackageList)
      })
      const goods = []
      shoppingGoods.forEach(good => {
        if (Number(good.isValid)) {
          goods.push({
            goodsId: good.goodsId,
            packageId: good.packageId,
            orderQuantity: Number(good.orderQuantity),
            goodsName: good.goodsName
          })
        }
      })
      console.log('************', goods, this.goodsList)
      this.goodsList.forEach(good => {
        // if (!good.isMultiSpec && good.packageList.length === 1) {
        //   const targetGood = goods.find(id => id.goodsId === good.goodsId && id.packageId === good.packageList[0].packageId)
        //   if (targetGood) {
        //     good.packageList[0].orderQuantity = targetGood.orderQuantity
        //   } else {
        //     // 购物车删除的商品
        //     good.packageList[0].orderQuantity = 0
        //   }
        // }
        if (!good.isMultiSpec) {
          good.packageList.forEach((pack: any, packIndex) => {
            const targetGood = goods.find(id => id.goodsId === pack.goodsId && id.packageId === good.packageList[packIndex].packageId)
            if (targetGood) {
              good.packageList[packIndex].orderQuantity = targetGood.orderQuantity
            } else {
              // 购物车删除的商品
              good.packageList[packIndex].orderQuantity = 0
            }
          })
        }
      })
    })
  }

  refreshActivityData (data: any) {
    console.log('refreshActivityData ***', data)
    this.activityData = data
  }
}
